import React, { useState, useEffect } from 'react';
import { FaUserAlt, FaChevronDown, FaChevronUp, FaBars, FaTimes } from "react-icons/fa"; // Import FaBars and FaTimes
import {useNavigate} from 'react-router-dom'
import { useUser } from '../../store/UserContext';
import { collection, getDocs, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/Config';
// Main App component for the responsive header
const DeBugHeader = () => {

  const navigate=useNavigate()
  const { currentUser, userData, logout } = useUser();
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    if (currentUser) {
      const cartRef = collection(db, 'cart');
      const q = query(cartRef, where('userId', '==', currentUser.uid));
      
      // Set up real-time listener for cart changes
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        setCartCount(querySnapshot.size);
      }, (error) => {
        console.error('Error listening to cart changes:', error);
      });

      // Cleanup function to unsubscribe when component unmounts or user changes
      return () => unsubscribe();
    } else {
      // Reset cart count when user is not logged in
      setCartCount(0);
    }
  }, [currentUser]);

  const handleLogout = async () => {
    try{
      await logout();
      navigate('/');
    }catch(error){
      console.error('Error logging out:', error);
    }
  };



  const [isOpen, setIsOpen] = useState(false); // State to manage mobile menu visibility
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to manage dropdown visibility

  // Function to toggle the mobile menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Close dropdown if mobile menu is closing
    if (isOpen) {
      setIsDropdownOpen(false);
    }
  };

  // Function to toggle the dropdown menu
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Function to close the dropdown
  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  return (
    <header className="bg-gradient-to-r from-indigo-600 to-purple-700 shadow-xl font-sans relative z-10 ">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo Section */}
        <div className="flex items-center">
          <a href="#" className="text-3xl font-extrabold text-white hover:text-yellow-300 transition-colors duration-300 transform hover:scale-105">
            Fashion Loop<span className="text-yellow-300">.In <sub >&#174;</sub></span>
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8 items-center">
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/');}}>
            Products
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
          </a>

          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/cart');}}>
            Cart <span className="cart-count ">{cartCount}</span>
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
          </a>

          {currentUser && <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/orders');}}>
            Orders
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
          </a>
          }
          {currentUser && <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/contact-us');}}>
            Contact Us
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
          </a>}
          {!currentUser && <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/login');}}>
            Login
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
          </a>}
          
          <div
            className="relative"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={closeDropdown}
          >
            <button
              onClick={toggleDropdown}
              className="flex items-center text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 focus:outline-none relative group"
            >
              {currentUser ? currentUser?.displayName : 'Account'}
              {/* Dropdown arrow icon */}
              <svg
                className={`ml-1 w-4 h-4 transform transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : 'rotate-0'}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
            </button>
            {isDropdownOpen && (
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 ring-1 ring-black ring-opacity-5 focus:outline-none animate-fade-in-down">
                {currentUser && <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200" onClick={()=>{navigate('/orders');}}>Order History</a>}  
                {currentUser && userData?.isAdmin && <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200" onClick={()=>{navigate('/admin-home');}}>Admin Panel</a>}  
                {currentUser && <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200" onClick={handleLogout}>Logout</a>}               
                {!currentUser && <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200" onClick={()=>{navigate('/login');}}>Login</a>}
                {!currentUser && <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200" onClick={()=>{navigate('/signup');}}>Signup</a>}
              </div>
            )}
          </div>

          
        </nav>

        {/* Mobile Menu Button (Hamburger Icon) */}
        <div className="md:hidden flex items-center">
          <button
            onClick={toggleMenu}
            className="text-white hover:text-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-300 rounded-md p-2 transition-colors duration-300"
            aria-label="Toggle menu"
          >
            {/* Hamburger Icon */}
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isOpen ? (
                // Close icon (X)
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              ) : (
                // Hamburger icon
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation (Conditional Rendering) */}
      {isOpen && (
        <nav className="md:hidden bg-indigo-700 border-t border-indigo-600 py-4 animate-fade-in-down">
          <div className="flex flex-col items-center space-y-4">
            <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/');}}>
                Products
            </a>
            <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/cart');}}>
              Cart <span className="cart-count ">{cartCount}</span>
            </a>
            <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/orders');}}>
                  Orders
            </a>
            <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/contact-us');}}>
              Contact Us
            </a>
            {/* Categories Dropdown for Mobile */}
            <div className="w-full text-center">
              <button
                onClick={toggleDropdown}
                className="flex items-center justify-center w-full text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 py-3 rounded-md hover:bg-indigo-600 focus:outline-none"
              >
                {currentUser ? currentUser?.displayName : 'Account'}
                <svg
                  className={`ml-1 w-4 h-4 transform transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : 'rotate-0'}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              {isDropdownOpen && (
                <div className="mt-2 bg-indigo-600 rounded-lg shadow-inner py-2 w-11/12 mx-auto animate-fade-in-down">
                  {currentUser && <a href="#" className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200 rounded-md" onClick={()=>{navigate('/orders');}}>Order History</a>}  
                  {currentUser && userData?.isAdmin && <a href="#" className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200 rounded-md" onClick={()=>{navigate('/admin-home');}}>Admin Panel</a>}  
                  {currentUser && <a href="#" className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200 rounded-md" onClick={handleLogout}>Logout</a>}               
                  {!currentUser && <a href="#" className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200 rounded-md" onClick={()=>{navigate('/login');}}>Login</a>}
                  {!currentUser && <a href="#" className="block px-4 py-2 text-white hover:bg-indigo-500 transition-colors duration-200 rounded-md" onClick={()=>{navigate('/signup');}}>Signup</a>}
                </div>
              )}
            </div>

           
          </div>
        </nav>
      )}
    </header>
  );
};

export default DeBugHeader; 
